// 팀 탭 상수 정의 (Single Source of Truth)
export const TEAM_TABS = {
    GOAL: 'goal',
    PROJECT: 'project',
    MEMBER: 'member',
    TEAM_SETTING: 'teamSetting',
} as const;

// 메뉴에서 사용할 탭들 (null과 team 제외)
export const TEAM_MENU_TABS = [
    TEAM_TABS.MEMBER,
    TEAM_TABS.PROJECT,
    TEAM_TABS.GOAL,
] as const;

// 모든 팀 탭 (null 포함)
export const ALL_TEAM_TABS = [
    TEAM_TABS.GOAL,
    TEAM_TABS.PROJECT,
    TEAM_TABS.MEMBER,
    TEAM_TABS.TEAM_SETTING,
] as const;

// 타입 추출
export type TeamTabValue = (typeof ALL_TEAM_TABS)[number] | null;
export type TeamMenuTabValue = (typeof TEAM_MENU_TABS)[number];

// 탭 메타데이터 (아이콘, 라벨 등)
export const TEAM_TAB_CONFIG = {
    [TEAM_TABS.MEMBER]: {
        label: 'item.member',
        icon: 'IconUsersGroup',
        order: 0,
    },
    [TEAM_TABS.PROJECT]: {
        label: 'item.project',
        icon: 'IconPresentation',
        order: 1,
    },
    [TEAM_TABS.GOAL]: {
        label: 'item.task',
        icon: 'IconSwipe',
        order: 2,
    },
} as const;
